import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CommonTable from "./CommonTable";
import "./rms.css";

const Cost = () => {
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={(event, value) => {
                handleChange(event, value);
              }}
              aria-label="lab API tabs example"
            >
              <Tab label="FREIGHT" value="1" />
              <Tab label="IPI" value="2" />
              {/* <Tab label="HOU" value="3" /> */}
            </TabList>
          </Box>
          {["1", "2"].map((item, index) => {
            return (
              <TabPanel key={index} value={item}>
                <CommonTable
                  demo={
                    item === "1"
                      ? "FREIGHT"
                      : item === "2"
                      ? "IPI"
                      : // : item === "3"
                        // ? "HOU"
                        ""
                  }
                />
              </TabPanel>
            );
          })}
        </TabContext>
      </Box>
    </>
  );
};

export default Cost;
